/**
 * @file geocode-address.tsx
 * @module app/modules/orders-delivery/components/geo/geocode-address
 * @description Reverse-geocodes a latitude/longitude pair for display in route cards.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import React, { useEffect, useState } from 'react';
import { searchGoogleAddressUsingLatLong } from '../../../../../utils/googleAddress';

const GeocodeAddress = ({ lat, lng }: any) => {
  const [address, setAddress] = useState('Loading...');
  useEffect(() => {
    (async () => {
      const geocode = await searchGoogleAddressUsingLatLong(lat, lng);
      const selected = geocode?.data?.[0];
      const selectedAddress = selected?.fullAddress || geocode?.parsed?.formattedAddress;

      if (selectedAddress) {
        setAddress(selectedAddress);
      } else {
        setAddress('No administrative area found');
      }
    })();
  }, [lat, lng]);
  return <span className="fs-15 fw-500">{address}</span>;
};
export default GeocodeAddress;
